import { render, staticRenderFns } from "./single-user.vue?vue&type=template&id=554fa496&"
import script from "./single-user.vue?vue&type=script&lang=js&"
export * from "./single-user.vue?vue&type=script&lang=js&"
import style0 from "./single-user.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports